import { ChevronRight } from '../../../icons';
import './PageHeader.css';

/**
 * 쪽 머리의 경로만 — `PageHeader` 가 그리는 것과 **같은 마크업 · 같은 클래스**다 (web 레인 W7a).
 *
 * 제 도움말 팝업 · 지표처럼 `PageHeader` 로 옮기면 동작이 바뀌는 머리(직위 · 직급)가 있어,
 * 그 머리는 그대로 두고 «경로 한 줄» 만 한 꼴로 맞출 때 쓴다(글자로 적던 «업무 › 인사 › 조직» 자리).
 * ★ `PageHeader` 를 쓸 수 있는 화면은 이것이 아니라 `PageHeader breadcrumb` 을 쓴다.
 */
export function PageCrumbs({ items }: { items: ReadonlyArray<string> }) {
  if (items.length === 0) return null;
  return (
    <nav className="wc-page-head__crumb" aria-label="현재 위치">
      {items.map((c, i) => (
        <span key={`${c}-${i}`} className="wc-page-head__crumb-item">
          {i > 0 && <ChevronRight className="wc-page-head__crumb-sep" aria-hidden />}
          <span aria-current={i === items.length - 1 ? 'page' : undefined}>{c}</span>
        </span>
      ))}
    </nav>
  );
}
